import { render, staticRenderFns } from "./slider-right-icon.vue?vue&type=template&id=4d2896aa&scoped=true"
import script from "./slider-right-icon.vue?vue&type=script&lang=js"
export * from "./slider-right-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2896aa",
  null
  
)

export default component.exports